import React, { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import ReactPaginate from "react-paginate";
import { useTranslation } from "react-i18next";
import { useRolePermission } from "../../../Hooks/useRolePermission";
import { useDispatch, useSelector } from "react-redux";
// component
import ButtonElement from "../../UI/Button";
import { getTableSkeletons } from "../../UI/Skeleton/Loader";
//helper
import { getLocalStorage } from "../../../Network/ApiService";
import { ls_vars } from "../../../Library/Constants";
import { scrollBar } from "../../Common/Header/ManageOutsideClickClose";
import { handleError } from "../../../Library/Utils";
//API
import {
  createCommonUtil,
  getCommonUtilById,
  getFilteredCommonUtils,
  updateCommonUtil,
  partialUpdateCommonUtil,
  removeCommonUtil,
  getCommonUtilList
} from "../../../Network/Core/CommonUtils/commonUtils";
//images
import images from "../../../Assets/images";
// css
// import "../../../Assets/css/style.css";
import "../../../Assets/css/customize.css";
import { useApiCall } from "Hooks/useApiCall";
import {
  CommonUtil,
  GetCommonUtilListParams,
} from "Network/Core/CommonUtils/types";
import DeleteConfirmationModal from "Components/Common/Modal/DeleteConfirmationModal";
import Pagination from "Components/UI/Pagination/Pagination";
import CommonUtilModal from "../../Common/Modal/CommonUtilModal";
import { error } from "console";

const index = () => {
  const { t } = useTranslation();
  const { call } = useApiCall();
  const { checkPermission } = useRolePermission();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const project = getLocalStorage(ls_vars.PROJECT_DATA);
  const region = getLocalStorage(ls_vars.REGION_ID);
  const dateFormate = getLocalStorage(ls_vars.USER_PREFERENCES)?.dateFormat?.id;

  const isLoading = useSelector((state: any) => state.loader.loading);
  //   const search = useSelector((state: any) => state.commonUtil.search);

  const [orderBy, setOrderBy] = useState<string>("type");
  const [commonUtilData, setCommonUtilData] = useState<CommonUtil[]>([]);
  const [statusIsASC, setStatusIsASC] = useState<boolean>(true);
  const [searchValue, setSearchValue] = useState<string>("");
  const [pageCount, setPageCount] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(10);
  const [isScrolling, setIsScrolling] = useState<boolean>(false);
  const [isCommonUtilModalOpen, setIsCommonUtilModalOpen] =
    useState<boolean>(false);
  const [isConfirmModalShow, setIsConfirmModalShow] = useState<boolean>(false);
  const [existingData, setExistingData] = useState<CommonUtil>(
    {} as CommonUtil
  );
  const [commonUtilToBeDeleted, setCommonUtilToBeDeleted] = useState<any>();
  const canViewProjectSettings = checkPermission(["project:settings:view"]);
  const canCreateProjectSettings = checkPermission(["project:settings:create"]);
  scrollBar(setIsScrolling);

  const handlePageClick = (data: { selected: number }) => {
    const { selected } = data;
    setPage(selected + 1);
  };

  const onChangePage = (e: { value: number }) => {
    setPerPage(e.value);
  };

  // Handle search input change
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchValue(value);
  };

  const getCommonUtilDetails = useCallback(async () => {

    try {
      let localPageCount = page;
      if (searchValue && page !== 1) {
        localPageCount = 1;
        setPage(1);
      }

      const params: GetCommonUtilListParams = {
        page: localPageCount,
        pageSize: perPage,
        search: searchValue,
        orderBy: orderBy,
      };

      const res = await getCommonUtilList(params, region);

      const { status, data, statusText } = res;
      switch (status) {
        case 200:
          const commonUtilResults = data?.results;
          const filterCommonUtilResults = commonUtilResults.filter((word:any) => !word.isDeleted);
          setCommonUtilData(filterCommonUtilResults);
          setPageCount(Math.ceil(data.count / perPage));
          break;
        case 400:
          handleError(data, t);
          break;
        default:
          toast.error(statusText);
          break;
      }
    } catch (err) {
      toast.error(t("Translation.error_something_went_wrong"));
    }
  }, [dispatch, page, perPage, orderBy, searchValue, t]); // Add all dependencies

  useEffect(() => {
    getCommonUtilDetails();
  }, [getCommonUtilDetails]); // Now we only need getCommonUtilDetails as a dependency

  const toggleSort = (field: string, isAcs: boolean) => {
    if (field !== "id") {
      setStatusIsASC(!isAcs);
      setOrderBy(isAcs ? field : "-" + field);
    }
  };

  const handleAddCommonUtil = () => {
    setExistingData({} as CommonUtil);
    setIsCommonUtilModalOpen(true);
  };

  const handleCommonUtilModalClose = () => {
    setIsCommonUtilModalOpen(false);
    getCommonUtilDetails();
  };

  const handleDeleteCommonUtil = async (commonUtil: any) => {
    if (!commonUtil || commonUtil.id === undefined) {
      console.error("Cannot delete commonUtil: Invalid ID");
      return;
    }
    call(
      () => removeCommonUtil(commonUtil.id, region),
      () => {
        toast.success(t("Translation.commonUtil_delete_success"));
        closeConfirmationModal();
        getCommonUtilDetails();
      },
      (error) => {
        if (error?.error) toast.error(t(`Translation.${error.error}`));
        else if (error) toast.error(t(`Translation.${error}`));
      }
    );
  };

  const closeConfirmationModal = () => {
    setIsConfirmModalShow(false);
  };

  return (
    <>
      {isCommonUtilModalOpen && (
        <>
          <CommonUtilModal
            handleClose={() => handleCommonUtilModalClose()}
            existingData={existingData}
          />
          <div className="modal-backdrop fade show" />
        </>
      )}
      {isConfirmModalShow && (
        <DeleteConfirmationModal
          isOpen={isConfirmModalShow}
          contentName={""}
          deleteContent={"CommonUtil"}
          closeModal={closeConfirmationModal}
          onConfirmAction={() => handleDeleteCommonUtil(commonUtilToBeDeleted)}
        />
      )}

      <div className="page-wrapper pb-0">
        <div className="page-header">
          <h3 className="page-title">{t("Translation.commonUtil_master")}</h3>
        </div>

        <div className="page-content custom-list-div">
          <div className="user-head-sec">
            <div className="booking-list-form">
              <div className="filter-wrapper">
                <div className="f-left">
                  <div className="form-group form-inline filter-search ml-0">
                    <img src={images.search} />
                    <input
                      type="text"
                      className="form-control"
                      placeholder={t("Translation.search")}
                      value={searchValue}
                      onChange={handleSearchChange}
                    />
                  </div>

                  {canCreateProjectSettings && (<ButtonElement
                    buttonLabel={t("Translation.commonUtil_master_add")}
                    handleClick={handleAddCommonUtil}
                    className="btn theme-btn invite-btn"
                  />)}
                </div>
              </div>
            </div>
          </div>

          <div className="booking-list-wrapper">
            <div
              className={`booking-list-data user-list-scroll scroll ${
                isScrolling ? "show-scroll" : "no-scroll"
              }`}
            >
              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-all"
                  role="tabpanel"
                  aria-labelledby="pills-all-tab"
                >
                  <div className="table-responsive">
                    {isLoading ? (
                      getTableSkeletons({
                        cols: 6,
                        rows: 3,
                        props: {
                          TableRowProps: {
                            style: { height: "75px" },
                          },
                        },
                      })
                    ) : (
                      <table className="display nowrap dataTable w-100">
                        <thead>
                          <tr>
                            <th
                              className="sorting sorting_asc"
                              onClick={() => toggleSort("name", statusIsASC)}
                            >
                              <span>{`${t("Translation.name")}`}</span>
                            </th>
                            <th
                              className="sorting"
                              onClick={() => toggleSort("type", statusIsASC)}
                            >
                              <span>{`${t("Translation.type")}`}</span>
                            </th>
                            {/* <th
                              className="sorting"
                              onClick={() => toggleSort("conditions", statusIsASC)}
                            >
                              <span>{`${t("Translation.conditions")}`}</span>
                            </th> */}
                            {(canCreateProjectSettings) && (<th
                              className="sorting"
                              onClick={() => toggleSort("actions", statusIsASC)}
                            >
                              {t("Translation.actions")}
                            </th>)}
                          </tr>
                        </thead>
                        <tbody>
                          {commonUtilData ? (
                            commonUtilData?.map((commonUtil) => (
                              <tr key={commonUtil.id}>
                                <td>{commonUtil.name}</td>
                                <td>{commonUtil.type}</td>
                                {/* <td>{commonUtil.conditions}</td> */}
                                {canCreateProjectSettings && (<td>
                                  <div className="action-buttons">
                                    {canCreateProjectSettings && (<button
                                      className="btn bg-transparent border-0"
                                      onClick={() => {
                                        setExistingData(commonUtil);
                                        setIsCommonUtilModalOpen(true);
                                      }}
                                    >
                                      <img src={images.Pen} alt="edit" />
                                    </button>)}
                                    {canCreateProjectSettings && (<button
                                      className="btn bg-transparent border-0"
                                      onClick={() => {
                                        setCommonUtilToBeDeleted(commonUtil);
                                        setIsConfirmModalShow(true);
                                      }}
                                    >
                                      <img
                                        src={images.DeleteRedIcon}
                                        alt="view"
                                      />
                                    </button>)}
                                  </div>
                                </td>)}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={7} className="text-center">
                                {t("Translation.no_commonUtil_found")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>

                  {commonUtilData.length > 0 ? (
                    <Pagination
                      page={page}
                      onPageChange={(v) => setPage(v)}
                      perPage={perPage}
                      onPerPageChange={({ value }) => setPerPage(value)}
                      pageTotalCount={pageCount}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default index;
